import { LogoMark, Text, colors, brandSurface } from '@khaddi/ui';
import { View } from 'react-native';
import { OnlineToggle } from './OnlineToggle';

export type HomeStat = { label: string; value: string; highlight?: boolean };

export type HomeHeaderProps = {
  name: string;
  online: boolean;
  togglePending: boolean;
  onToggle: (online: boolean) => void;
  stats: HomeStat[];
};

export const HomeHeader = ({ name, online, togglePending, onToggle, stats }: HomeHeaderProps) => (
  <View style={{ ...brandSurface, paddingTop: 18, paddingHorizontal: 20, paddingBottom: 70, gap: 18 }}>
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
      <LogoMark size={40} />
      <View style={{ flex: 1, minWidth: 0 }}>
        <Text variant="caption" color={colors.text} numberOfLines={1}>
          Khao Ddi Shipper
        </Text>
        <Text variant="bodyStrong" color={colors.text} style={{ fontSize: 16 }}>
          Chào {name}
        </Text>
      </View>
      <OnlineToggle online={online} pending={togglePending} onChange={onToggle} />
    </View>
    <View style={{ flexDirection: 'row', gap: 8 }}>
      {stats.map((stat) => (
        <View key={stat.label} style={{ flex: 1, gap: 2 }}>
          <Text variant="caption" color={colors.text}>
            {stat.label}
          </Text>
          <Text variant="display" color={colors.text} style={{ fontSize: 26, lineHeight: 29 }} numeric>
            {stat.value}
          </Text>
        </View>
      ))}
    </View>
  </View>
);
